<template>
  <div class="row" v-if="pageLoad">
    <div class="col-xxl-8 order-2 order-xl-1">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-body p-10">
          <ul class="settings-tabs ps-0 mb-0 list-unstyled">
            <li>
              <router-link
                to="/account-settings"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition settings-tab-link"
              >
                {{ $t('settings.personalInfo') }}
              </router-link>
            </li>
            <li>
              <router-link
                to="/settings-change-password"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition settings-tab-link"
              >
                {{ $t('settings.changePassword') }}
              </router-link>
            </li>
            <li>
              <router-link
                to="/settings-organization"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition settings-tab-link"
              >
                {{ $t('settings.editOrganization') }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card"
      >
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <form>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    {{ $t('settings.organizationName') }}
                  </label>
                  <input
                    v-model="organizationName"
                    readonly
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    {{ $t('settings.firstName') }}
                  </label>
                  <input
                    v-model="userName"
                    readonly
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    {{ $t('settings.lastName') }}
                  </label>
                  <input
                    v-model="userName"
                    readonly
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    {{ $t('settings.email') }}
                  </label>
                  <input
                    v-model="email"
                    readonly
                    type="email"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. adam127704@gmail.com"
                  />
                </div>
              </div>
            </div>
          </form>

          <!-- Switch de langue placé ici, en dessous du formulaire -->
          <div class="language-switcher-wrapper mt-20 mt-md-25 pt-15 pt-md-20 border-top">
            <div class="d-flex align-items-center justify-content-between">
              <span class="text-black fw-semibold fs-14">
                {{ $t('settings.language') }}
              </span>
              <div class="language-switcher">
                <button 
                  class="btn btn-sm rounded-0 transition"
                  :class="{ active: currentLocale === 'fr' }"
                  @click="changeLanguage('fr')"
                >
                  FR
                </button>
                <button 
                  class="btn btn-sm rounded-0 transition"
                  :class="{ active: currentLocale === 'en' }"
                  @click="changeLanguage('en')"
                >
                  EN
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Affichage d'un loader pendant le chargement -->
  <div v-else class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, reactive, inject, computed } from "vue";
import { useI18n } from "vue-i18n";
import * as yup from 'yup';
import { User } from "@/utils/Model";
import BlotFormatter from "quill-blot-formatter";
import ImageUploader from "quill-image-uploader";
import axios from "axios";
import router from '../../../router/index'
import { checkSessionValidate } from "@/utils/function";

const backApi = inject('back');
const { locale, t } = useI18n();

// Récupérer la langue actuelle
const currentLocale = computed(() => locale.value);
console.log('LA LANGUE ACTUELLE EST =====', currentLocale.value);

const changeLanguage = (lang: string) => {
  console.log('LA LANGUE CHOISIE EST =====', lang);
  locale.value = lang;
  localStorage.setItem("lang", lang);
};

let token: string | null = localStorage.getItem('login_token');
let codeOrganization: string | null = localStorage.getItem('organization_code');
let codeUser: string | null = localStorage.getItem('code');
let role: string | null = localStorage.getItem('role');

let organizationName: string | null = localStorage.getItem('organization_name');
let userName: string | null = localStorage.getItem('name');
let email: string | null = localStorage.getItem('email');

const user = ref({} as User);
const pageLoad = ref(false);
const isLoading = ref(true); // Ajout d'un état de chargement

const showUserInfo = () => {
  axios.get(backApi + '/secure/users/' + codeUser + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      user.value = response.data;
      console.log(response.data);
      // Ne pas modifier pageLoad ici
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        } else {
          console.log(error.response);
        }
      }
    }).finally(() => {
      // Une fois les données chargées, afficher la page
      pageLoad.value = true;
      isLoading.value = false;
    });
}

onMounted(() => {
  checkSessionValidate(1);
  
  // Récupérer la langue depuis localStorage
  const savedLang = localStorage.getItem('lang');
  if (savedLang) {
    locale.value = savedLang;
  }
  
  // Appeler la fonction pour charger les données
  showUserInfo();
});
</script>

<style scoped>

.spinner-border {
  width: 3rem;
  height: 3rem;
}

.settings-tab-link {
  color: #7a1f2b;
  padding: 10px 15px;
  border: 1px solid #7a1f2b;
}

.settings-tab-link:hover {
  background-color: #7a1f2b;
  color: #ffffff;
}

.settings-tab-link.router-link-active,
.settings-tab-link.router-link-exact-active {
  background-color: #7a1f2b;
  color: #ffffff;
  border-color: #7a1f2b;
}
.language-switcher-wrapper {
  border-top: 1px solid #e5e5e5;
}

.language-switcher {
  display: flex;
  gap: 5px;
}

.language-switcher button {
  border: 1px solid #EB9355;
  background: white;
  color: #EB9355;
  font-weight: 600;
  padding: 5px 15px;
  font-size: 13px;
  min-width: 45px;
  transition: all 0.3s ease;
}

.language-switcher button.active {
  background-color: #EB9355;
  color: white;
}

.language-switcher button:hover {
  background-color: #EB9355;
  color: white;
  opacity: 0.9;
}

/* Style pour le loader */
.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style>